// extracted by mini-css-extract-plugin
module.exports = {"fields":"ContactFields_fields__x1Msc","isSingleNameField":"ContactFields_isSingleNameField__RZ8WK"};